import { TradingOrder, TradingOrderType } from "../config/trading";
import { EditingPosition } from "./editingPosition";
import { EditingOrder } from "./editingOrder";


export class EditingTargetOrder extends EditingOrder {
    stop_pnl?: number;
    constructor(pos: EditingPosition, trd: TradingOrder) {
        if (trd.type != TradingOrderType.TakeProfit)
            throw 'not target order';
        super(pos, trd);
    }
}
